module.exports = __webpack_public_path__ + "media/images/football-image-30d52696b072f2c9d44875535bdf1d73.jpg";